import { dataMember, required } from 'santee-dcts';
import { isNil } from 'lodash';

export class TestResult {
    @dataMember()
    public stringResult: string;

    @dataMember()
    @required({ nullable: true })
    public numericResult: number;

    @dataMember()
    @required({ nullable: true })
    public unit: string;

    @dataMember()
    @required({ nullable: true })
    public min: number;

    @dataMember()
    @required({ nullable: true })
    public max: number;

    @dataMember()
    @required({ nullable: true })
    public rangeTextValue: string;

    @dataMember()
    @required()
    public isSIUnit: boolean;

    @dataMember()
    @required({ nullable: true })
    public sequence: number;

    public get hasValidNumericRange() {
        return !isNil(this.min) && !isNil(this.max);
    }

    public get range() {
        return this.hasValidNumericRange ? `${this.min} - ${this.max}` : this.rangeTextValue || '';
    }

    public get rangeWithUnits() {
       return (this.hasValidNumericRange && this.unit) ? `${this.range} ${this.unit}` : this.range;
    }
}